module.exports = __webpack_public_path__ + "img/10.da3b585f.png";